import { shallowMount, createLocalVue, config } from '@vue/test-utils';
import Vuex from 'vuex';
import ColorCrewContact from './ColorCrewContact';

const localVue = createLocalVue();
localVue.use(Vuex);
config.mocks['MRConfig'] = {
  cancelSubPhone: '1-123-456-5555'
};

describe('ColorCrewContact', () => {
  let wrapper;
  let store;

  beforeEach(()=> {
    store = new Vuex.Store({
      modules: {
        subscriptions: {
          namespaced: true,
          state: {
            cancelData: {
              reason: {
                id: 12,
                disposition_reason_id: 34,
                reason: 'Some reason'
              }
            }
          }
        }
      }
    });

    wrapper = shallowMount(ColorCrewContact, {
      localVue,
      store
    });
  });

  describe('content', () => {
    test('general snapshot', () => {
      expect(wrapper.html()).toMatchSnapshot();
    });
  });
});
